import houseContractTemplate from '@/views/person-center/project/contract-comp/house-contract-template/house-contract-template.vue';
import ProjectService from '@/views/person-center/project/project.service.js';
import Service from '@/service/index.js';
// import RegExpObj from '@/utils/regExp.js';
import { successMessage, errorMessage } from '@/utils/message.js';
export default {
  components: {
    houseContractTemplate
  },
  data() {
    var oninput = (rule, value, callback) => {
      console.log(value, 'value');
      if(!value){
        callback(new Error('提示请输入1-1000的整数'));
      } else if(value < 0 || value > 1000){
        callback(new Error('请输入1-1000'));
      } else {
        callback();
      }
    };
    const installmentSumTermValidator = (rule, value, callback) => {
      if (value === '' || value === null) {
        return callback(new Error('请输入分期付款的期数'));
      } else if(value <= 0 || value > 100){
        return callback(new Error('1-100'));
      } else {
        callback();
      }
    };
    const installmentPerYearValidator =  (rule, value, callback) => {
      if (value === '' ||  value === null) {
        return callback(new Error('请输入每期多少年'));
      } else if(value <= 0 || value > 10){
        return callback(new Error('1-10'));
      } else {
        callback();
      }
    };
    const installmentPerYearPriceAddPercentValidator = (rule, value, callback) => {
      if (value === '' || value === null) {
        return callback(new Error('请输入每期承包费递增百分比'));
      } else if(value < 0 || value > 100){
        return callback(new Error('0-100'));
      } else {
        callback();
      }
    };
    const contractEffectivePeriodValidator = (rule, value, callback) => {
      if (value === '' ||  value === null) {
        return callback(new Error('请输入'));
      } else if(value <= 0 || value > 100){
        return callback(new Error('1-100'));
      } else {
        callback();
      }
    };
    const afterYearsPayNextPriceValidator =  (rule, value, callback) => {
      if (value === '' || !value) {
        return callback(new Error('请输入'));
      } else if(value <= 0 || value > 10){
        return callback(new Error('1-10'));
      } else if(!this.ruleForm.afterDatePayNextPrice) {
        return callback(new Error('请选择日期'));
      } else {
        callback();
      }
    };
    return {
      pickerOptions: {
        disabledDate (time) {
          const year = new Date().getFullYear();
          const showTime = time.getTime();
          const lastYear = `${year-1}-12-31`;
          const nowYear = `${year}-12-31`;
          const twoMonth = `${year}-2-29`;
          const dayNum = new Date(year, 2, 0).getDate();
          if (dayNum === 29) {
            return (showTime <= new Date(lastYear).getTime()) || (showTime > new Date(nowYear).getTime()) || (showTime === new Date(twoMonth).getTime());
          } else {
            return (showTime <= new Date(lastYear).getTime()) || (showTime > new Date(nowYear).getTime());
          }
        }
      },
      // 设置只能选择当前日期及之后的日期
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; // 如果没有后面的-8.64e7就是不可以选择今天的
        }
      },
      checked: true,
      checked1: false,
      ruleForm: {
        projectType: '',
        partybLeasesBidUseFor: '',
        sumCurrentPrice: '',
        contractFeePerYear: 0, // 每年租金
        remainMoney: 0,
        lastPayDate: '', // 剩余交付日期
        inKindOrOtherMethod: '',
        otherMethod: '',
        projectDeposit: '', // 项目定金
        contractDeposit: '',
        payType: 1,
        paymentContractDepositAgreedDay: '', // 支付合同定金约定
        refundContractDepositAgreedDay: '', // 返还合同定金约定
        lastDeliverDate: '', // 最晚交付日期
        resolveDisputesWays: '', // 解决争议途径
        useBidMatterExpensesAgreement: '',
        otherAgreement: '',
        partyaOverdueProportion: '', // 甲方逾期违约金比例
        partyaOverdueDate: '', // 乙方逾期违约金比例
        partybOverdueProportion: '', // 乙方逾期违约金比例
        partybOverdueDate: '', // 乙方逾期超时日
        // remainingPriceOfFirstInstallment: '',
        paymentCirculationPriceCycle: '',
        paymentTransferPriceDate: '',

        installmentSumTerm: '',
        installmentPerYear: '',
        installmentPerYearPriceAddPercent: '',
        installmentPriceOfFirst: '',
        remainingPriceOfFirstInstallment: '',
        contractEffectivePeriod: '',
        afterYearsPayNextPrice: '',
        afterDatePayNextPrice: ''
      },
      projectDepositList: [
        {code: 1, 'value': '需要定金'},
        {code: 2, 'value': '不需要定金'}
      ],
      useBidList: [
        {code: 1, 'value': '甲方承担'},
        {code: 2, 'value': '乙方承担'}
      ],
      rules: {
        // partybLeasesBidUseFor: [
        //   { required: true, message: '请输入乙方承租标的用于', trigger: 'blur' }
        // ],
        contractFeePerYear: [
          { required: true, message: '请输入每年（期）租金', trigger: 'blur' }
        ],
        lastPayDate: [
          { required: true, message: '请选择剩余交付日期', trigger: 'blur' }
        ],
        installmentSumTerm: [
          { required: true, validator: installmentSumTermValidator, trigger: 'blur' }
        ],
        installmentPerYear: [
          { required: true, validator: installmentPerYearValidator, trigger: 'blur' }
        ],
        installmentPerYearPriceAddPercent: [
          { required: true, validator: installmentPerYearPriceAddPercentValidator, trigger: 'blur' }
        ],
        // installmentPriceOfFirst: [
        //   { required: true, message: '请输入第一期价款金额', trigger: 'blur' }
        // ],
        afterYearsPayNextPrice: [
          { required: true,  validator: afterYearsPayNextPriceValidator, trigger: 'change' }
        ],
        contractEffectivePeriod: [
          { required: true, validator: contractEffectivePeriodValidator, trigger: 'blur' }
        ],
        inKindOrOtherMethod: [
          { required: true, message: '请输入以实物或者实物折资方式', trigger: 'blur' }
        ],
        projectDeposit: [
          { required: true, message: '请选择是否需要项目定金', trigger: 'change' }
        ],
        contractDeposit: [
          { required: true, message: '请输入合同定金', trigger: 'blur' }
        ],
        paymentContractDepositAgreedDay: [
          { required: true, message: '请输入支付合同定金约定日', trigger: 'blur' }
        ],
        refundContractDepositAgreedDay: [
          { required: true, message: '请输入返还合同定金约定日', trigger: 'blur' }
        ],
        lastDeliverDate: [
          { required: true, message: '请选择最晚交付日期', trigger: 'blur' }
        ],
        resolveDisputesWays: [
          { required: true, message: '请选择解决争议途径', trigger: 'blur' }
        ],
        useBidMatterExpensesAgreement: [
          { required: true, message: '请选择使用标的发生费用约定', trigger: 'change' }
        ],
        partyaOverdueProportion: [
          { required: true, validator: oninput, trigger: 'blur' }
        ],
        partyaOverdueDate: [
          { required: true, validator: oninput, trigger: 'blur' }
        ],
        partybOverdueProportion: [
          { required: true, validator: oninput, trigger: 'blur' }
        ],
        partybOverdueDate: [
          { required: true, validator: oninput, trigger: 'blur' }
        ],
        // contractEffectivePeriod: [
        //   { required: true, message: '请输入合同生效后多少天支付第一期剩余价款', trigger: 'blur' }
        // ],
        paymentCirculationPriceCycle: [
          { required: true, message: '请输入支付租金周期', trigger: 'blur' }
        ],
        paymentTransferPriceDate: [
          { required: true, message: '请选择当年支付租金日期', trigger: 'change' }
        ]
      },
      dialogFormVisible: false,
      createContractInfo: {
        // projectAssets: {}
      },
      disputeWay: null, // 争议解决途径
      contractPeriod: null, // 承包期限
      previewContract: null, // 预览合同的信息
      massifType: null // 地块类型
    };
  },
  watch: {
    'ruleForm.projectDeposit'(value, oldValue) {
      if(Number(value) === 2 || Number(oldValue) === 2) {
        this.ruleForm = {
          ...this.ruleForm,
          contractDeposit: '',
          paymentContractDepositAgreedDay: '',
          refundContractDepositAgreedDay: ''
        };
      }
    },
    'ruleForm.installmentPriceOfFirst'(newName, oldName) {
      if(newName !== oldName) {
        this.ruleForm.remainingPriceOfFirstInstallment = this.ruleForm.installmentPriceOfFirst - (this.createContractInfo.marginSubServiceFee);
      }
    }
  },
  created() {
    // console.log(this.type, '瑕疵声明及重大事项提示');
    this.ruleForm.userId = this.$route.query.userId;
    this.ruleForm.projectId = this.$route.query.id;
    this.ruleForm.projectType = this.$route.query.projectType;
    this.getDictList();
  },
  computed: {
  },
  mounted() {
    this.getContractData();
  },
  methods: {
    installmentPriceOfFirstValidator(rule, value, callback) {
      if (value === '') {
        return callback(new Error('请输入第一期价款金额'));
      } else if(value < this.createContractInfo.marginSubServiceFee){
        return callback(new Error('不能小于竞价保证金-服务费'));
      } else {
        callback();
      }
    },
    change(){
      this.$forceUpdate();
    },
    // 获取用户类型 字典查询
    getDictList () {
      const obj = {
        DISPUTE_RESOLUTION_WAY: 'disputeWay',
        CONTRACT_PERIOD: 'contractPeriod',
        MASSIF_TYPE: 'massifType'
      };
      Object.keys(obj).forEach((key) => {
        Service.getSelectList(key).then(res => {
          if (res && res.code === '0') {
            this[obj[key]] = res.data;
          }
        });
      });
    },
    // 数据回显
    getContractData() {
      ProjectService.toCreateContract(this.ruleForm.projectId, this.ruleForm.userId, this.ruleForm.projectType).then(res => {
        if (res && res.code === '0') {
          this.createContractInfo = {
            ...res.data
          };
          for (let key in this.createContractInfo) {
            // 第一期价款金额如果小于0 则等于0
            if(res.data.installmentPriceOfFirst < 0) {
              this.createContractInfo.installmentPriceOfFirst = 0;
            }
            if (this.ruleForm.hasOwnProperty(key)) {
              this.ruleForm[key] = this.createContractInfo[key];
            }

            // if(key === 'contractFeePerYear'){
            //   this.ruleForm.contractFeePerYear = this.createContractInfo.everyYearSumPrice;
            // }
            // 其他途径复选
            if(key === 'resolveDisputesWays' && res.data.resolveDisputesWays) {
              this.ruleForm.resolveDisputesWays = String(this.ruleForm.resolveDisputesWays);
              this.checked1 = true;
            }
          }
          console.log(this.ruleForm);
        }
      });
    },
    previousStep () {
      this.$router.back();
    },
    // 预览合同
    previewBtn() {
      this.$refs['signUpForm'].validate((valid) => {
        if (valid) {
          this.dialogFormVisible = true;
          this.submit(false);
        } else {
          return false;
        }
      });
    },
    // 立即提交
    test() {
      this.$refs['signUpForm'].validate((valid) => {
        if (valid) {
          this.$confirm('是否继续提交合同信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.submit(true);
          }).catch(() => {
          });
        } else {
          return false;
        }
      });
    },
    // 确认提交按钮
    submit(isSave) {
      // 保存接口传参
      ProjectService.createContract({
        isSave: isSave,
        ...this.ruleForm
      }).then(res => {
        if(isSave) {
          if (res && res.code === '0') {
            successMessage('创建成功');
            this.$router.push('/person-center/project/roll-out-project/list');
          } else if (res && res.reason) {
            errorMessage(res && res.reason);
          } else {
            errorMessage('创建失败');
          }
        } else {
          ProjectService.displayWoodsContract(
            this.ruleForm.projectId,
            this.ruleForm.projectType,
            this.ruleForm.userId,
            '1'
          ).then(res => {
            if (res && res.code === '0') {
              this.previewContract = res.data;
              // this.getContractData();
            }
          });
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('创建失败');
        }
      });
    }
  }
};
